import { InjectionToken } from '@angular/core';

/**
 * Where a host sends report PDFs that never arrived. Optional on purpose: the preview works without one, and only the
 * public viewer reports anything today — a host that provides nothing stays silent rather than carrying a no-op.
 */
export interface DocumentPdfTelemetry {
  /**
   * `error` is the request that failed or the `TimeoutError` of the preview deadline, for the host to classify;
   * `durationMs` is how long the recipient waited for it, retries included.
   */
  pdfLoadFailed(error: unknown, durationMs: number): void;
}

export const DOCUMENT_PDF_TELEMETRY = new InjectionToken<DocumentPdfTelemetry>('DOCUMENT_PDF_TELEMETRY');
